module.exports = __webpack_public_path__ + "img/logo.b82322b1.png";